module.exports = __webpack_public_path__ + "static/img/futureFeatures.315b527.png";